import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ResumeBuilderService } from '../../gen2ai/resume-builder.service';

@Component({
  selector: 'app-resume-builder',
  templateUrl: './resume-builder.component.html',
  styleUrls: ['./resume-builder.component.scss']
})
export class ResumeBuilderComponent implements OnDestroy {
  form = this.fb.group({
    currentResume: ['', [Validators.required, Validators.minLength(30)]],
    jobDescription: ['', [Validators.required, Validators.minLength(30)]]
  });

  isLoading = false;
  error: string | null = null;
  generatedResume = '';

  private sub = new Subscription();

  constructor(private fb: FormBuilder, private api: ResumeBuilderService) {}

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  /** Enables button as soon as input is valid (and not loading) */
  get canGenerate(): boolean {
    return !this.isLoading && this.form.valid;
  }

  generate(): void {
    this.error = null;
    this.generatedResume = '';

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const currentResume = (this.form.value.currentResume || '').trim();
    const jobDescription = (this.form.value.jobDescription || '').trim();

    this.isLoading = true;

    this.sub.add(
      this.api.generateResume(currentResume, jobDescription).subscribe({
        next: (text) => {
          this.generatedResume = text;
          this.isLoading = false;
        },
        error: (e: Error) => {
          this.error = e.message || 'Failed to generate resume.';
          this.isLoading = false;
        }
      })
    );
  }

  clear(): void {
    this.form.reset({ currentResume: '', jobDescription: '' });
    this.generatedResume = '';
    this.error = null;
  }

  async copyOutput(): Promise<void> {
    if (!this.generatedResume) return;
    try {
      await navigator.clipboard.writeText(this.generatedResume);
    } catch {
      // ignore
    }
  }
}
